window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

const build = document.head.querySelector('meta[name="build-id"]');

if (build) {
    window.axios.defaults.headers.common['X-BUILD-ID'] = build.content;
} else {
    console.error('Mix build not found.');
}


window.axios.interceptors.response.use((response) => {
    return response;
}, function (error) {
    if (error.response.status === 419) {
        console.error('CSRF Token mismatch. Reloading page in 5 seconds');

        setTimeout(() => {
            location.reload();
        }, 5000);
    }

    return Promise.reject(error);
});

window.moment = require('moment');

window.domurl = require('domurl');

import Highcharts from 'highcharts';
import HighChartsOptions from './configuration/highcharts.json';

Highcharts.setOptions(HighChartsOptions);

require('highcharts/highcharts-3d')(Highcharts);
require('highcharts/highcharts-more')(Highcharts);
require('highcharts/modules/heatmap')(Highcharts);
require('highcharts/modules/treemap')(Highcharts);

import HighchartsVue from 'highcharts-vue';

Vue.use(HighchartsVue);

import Vue from 'vue';

import Toasted from 'vue-toasted';

Vue.use(Toasted);

import VideoBg from 'vue-videobg';
Vue.component('video-bg', VideoBg);

import lineClamp from 'vue-line-clamp';

Vue.use(lineClamp);

import currency from 'v-currency-field';

Vue.use(currency);

window.fileDownload = require('js-file-download');

import VueCurrencyFilter from 'vue-currency-filter';

Vue.use(VueCurrencyFilter,
    [
        {
            symbol: 'R',
            thousandsSeparator: ' ',
            fractionCount: 2,
            fractionSeparator: ',',
            symbolPosition: 'front',
            symbolSpacing: true
        },
        {
            name: 'currency_no_decimals',
            symbol: 'R',
            thousandsSeparator: ' ',
            fractionCount: 0,
            fractionSeparator: '',
            symbolPosition: 'front',
            symbolSpacing: true
        }
    ]
);

import VueCarousel from 'vue-carousel';

Vue.use(VueCarousel);

import VueQrcode from '@chenfengyuan/vue-qrcode';

Vue.component(VueQrcode.name, VueQrcode);

import InputFacade from 'vue-input-facade';

Vue.use(InputFacade);

import Sticky from 'vue-sticky-directive';

window.fileDownload = require('js-file-download');

Vue.use(Sticky);

import VuePlyr from 'vue-plyr'

Vue.use(VuePlyr, {
    plyr: {
        controls: ['fullscreen', 'play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'settings'],
        fullscreen: {enabled: true, fallback: true, iosNative: false, container: null},
    },
    emit: ['ended']
});

// TODO: TEMP FIX FOR ROUTER ERROR - CALL
// [vue-router] Failed to resolve async component default: TypeError: Cannot read property 'call' of undefined
require('./vue.scss');
